import { useMemo } from 'react';

import { useUserPermissions } from './contexts/PermissionsProviderContext';
import { Permission } from './permissions';

export const useOrderManagementPermissions = () => {
    const {
        userPermissions: {
            CAN_CREATE_TPO_PROJECT_TYPES: userHasLegacyIntakePermissions,
            CAN_CREATE_PROJECTS: canCreateProjects,
            CAN_CREATE_ORDER_TEMPLATES: canCreateOrderTemplates,
            CAN_EDIT_ORDER_TEMPLATES: canEditOrderTemplates,
            CAN_CREATE_ORDERS: canCreateOrders,
            CAN_EDIT_ORDERS: userCanEditOrders,
            CAN_CANCEL_IN_PROGRESS_ORDERS: userCanCancelInProgressOrders,
        },
    } = useUserPermissions([
        Permission.CAN_CREATE_TPO_PROJECT_TYPES,
        Permission.CAN_CREATE_PROJECTS,
        Permission.CAN_CREATE_ORDER_TEMPLATES,
        Permission.CAN_EDIT_ORDER_TEMPLATES,
        Permission.CAN_CREATE_ORDERS,
        Permission.CAN_EDIT_ORDERS,
        Permission.CAN_CANCEL_IN_PROGRESS_ORDERS,
    ]);

    return useMemo(() => {
        return {
            userCanCreateProjects: userHasLegacyIntakePermissions || canCreateProjects,
            userCanCreateOrderTemplates: userHasLegacyIntakePermissions || canCreateOrderTemplates,
            userCanEditOrderTemplates: userHasLegacyIntakePermissions || canEditOrderTemplates,
            userCanCreateOrders: userHasLegacyIntakePermissions || canCreateOrders,
            userCanEditOrders,
            userCanCancelInProgressOrders,
        };
    }, [
        userHasLegacyIntakePermissions,
        canCreateProjects,
        canCreateOrderTemplates,
        canEditOrderTemplates,
        canCreateOrders,
        userCanEditOrders,
        userCanCancelInProgressOrders,
    ]);
};
